// 登录设备信息(截图泄露时可据此溯源)
export interface DeviceInfo {
  browser: string;
  os: string;
  platform: string;
  userAgent: string;
  screen: string;
}

function detectBrowser(ua: string): string {
  if (/Edg\//.test(ua)) return 'Edge';
  if (/OPR\/|Opera/.test(ua)) return 'Opera';
  if (/Firefox\//.test(ua)) return 'Firefox';
  if (/Chrome\//.test(ua)) return 'Chrome';
  if (/Safari\//.test(ua)) return 'Safari';
  return 'Unknown';
}

function detectOS(ua: string): string {
  if (/Windows/.test(ua)) return 'Windows';
  if (/Mac OS X/.test(ua)) return 'macOS';
  if (/Android/.test(ua)) return 'Android';
  if (/iPhone|iPad|iPod/.test(ua)) return 'iOS';
  if (/Linux/.test(ua)) return 'Linux';
  return 'Unknown';
}

export function deviceInfo(): DeviceInfo {
  const ua = navigator.userAgent;
  const screen = `${window.screen?.width || 0}×${window.screen?.height || 0}`;
  return {
    browser: detectBrowser(ua),
    os: detectOS(ua),
    platform: navigator.platform || 'Unknown',
    userAgent: ua,
    screen,
  };
}
